module.exports = __webpack_public_path__ + "static/img/outwork-green.a25156c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outwork-green.png
// module id = ZioR
// module chunks = 62